import {ItemType} from '../types';
import {DropResult} from 'react-beautiful-dnd';
import {priority} from '@priority-software/priority-proto-api/lib';

/**
 * Reorder items in parent (or single) list.
 */
export const reorder = (list: ItemType[], startIndex: number, endIndex: number) => {
    let _endIndex = endIndex;
    // special treatment for the mainArea of TabsDesign
    // that doesn't let to throw the items higher than the mainArea (the first in the list)
    if (
        list.length &&
        (list[0] as priority.netitems.form.RowViewTabsDesign).ColumnsDesign &&
        endIndex === 0
    ) {
        _endIndex = 1;
    }
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(_endIndex, 0, removed);
    return result;
};

// Reorder items in child list
export const reorderChildList = (
    data: ItemType[],
    startIndex: number,
    endIndex: number,
    tabIndex: number
) => {
    const sourceClone = Array.from(data);
    const res = reorder(
        (sourceClone[tabIndex] as priority.netitems.form.RowViewTabsDesign).ColumnsDesign,
        startIndex,
        endIndex
    ) as priority.netitems.form.IRowViewColumnsDesign[];
    if (endIndex === 0) {
        res[endIndex].Newarea = false;
    }
    (sourceClone[tabIndex] as priority.netitems.form.RowViewTabsDesign).ColumnsDesign = res;
    return sourceClone;
};

// add result type
export const moveBetweenLists = (data: ItemType[], result: DropResult): ItemType[] => {
    const dataClone = Array.from(data);

    const droppableSrcIndex = getTabIndexByDroppableId(result.source.droppableId);
    const droppableDestIndex = getTabIndexByDroppableId(result.destination.droppableId);

    const sourceSection = (dataClone[droppableSrcIndex] as priority.netitems.form.RowViewTabsDesign)
        .ColumnsDesign;
    const destSection = (dataClone[droppableDestIndex] as priority.netitems.form.RowViewTabsDesign)
        .ColumnsDesign;

    const [removed] = sourceSection.splice(result.source.index, 1);
    destSection.splice(result.destination.index, 0, removed);

    (dataClone[droppableSrcIndex] as priority.netitems.form.RowViewTabsDesign).ColumnsDesign =
        sourceSection;
    (dataClone[droppableDestIndex] as priority.netitems.form.RowViewTabsDesign).ColumnsDesign =
        destSection;

    return dataClone;
};

export const getTabIndexByDroppableId = (droppableId: string): number => {
    const droppableArr = droppableId.split('-');
    return Number(droppableArr[droppableArr.length - 1]);
};
